'use client';

import { ReactNode } from 'react';
import { VenueProvider, VenuesContext, VenuesProvider } from '@/features/venue-router';
import { VenuesFilters } from './types';

type Props = {
    filters?: VenuesFilters;
    children?: ReactNode;
};

export const VenuesFor = ({ filters, children }: Props) => {
    return (
        <VenuesProvider filter={filters}>
            <VenuesContext.Consumer>
                {({ data }) =>
                    data.map((venue) => (
                        <VenueProvider key={venue.apiPartnerSettingsId} value={{ data: venue }}>
                            {children}
                        </VenueProvider>
                    ))
                }
            </VenuesContext.Consumer>
        </VenuesProvider>
    );
};
